<template>
  <section class="disclaimer">
    <header class="disclaimer-header">
      <span class="icon icon-warning"></span>
      <p class="disclaimer-header--text">
        {{ $t('Web.disclaimer.text') }}
      </p>
    </header>

    <div class="disclaimer-content">
      <div class="downloads-list">
        <div class="download-item">
          <img
            src="@/assets/img/junelight-Appstore-DE_original.png"
            alt="Appstore"
            class="download-img"
          />
          <a
            href="https://itunes.apple.com/de/app/junelight/id1450390324?ls=1&mt=8"
            class="download-link"
            >App Store - Apple</a
          >
        </div>
        <div class="download-item">
          <img
            src="@/assets/img/junelight-Googleplaystore-DE_original.png"
            alt="Appstore"
            class="download-img"
            target="_blank"
          />
          <a
            href="https://play.google.com/store/apps/details?id=com.siemens.power3"
            class="download-link"
            target="_blank"
            >Google Play Store</a
          >
        </div>
      </div>
    </div>

    <slot name="footer"></slot>
    <slot name="append"></slot>
  </section>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.disclaimer {
  $border-radius: 0.5rem; // 8px

  display: flex;
  flex-direction: column;
  width: 35vw;
  max-width: 550px;
  min-width: 360px;
  border-radius: $border-radius;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
  border: solid 0.5px $cloudy-blue;
  background-color: $cloudy-blue-20;

  &-header {
    display: flex;
    background-color: $pale-grey;
    padding: 2rem;
    border-top-left-radius: $border-radius;
    border-top-right-radius: $border-radius;

    &--text {
      padding-left: 2.5rem;
      font-size: 0.875rem; // 14px
      line-height: 1.4;
    }
  }

  &-content {
    padding: 2rem;
    box-shadow: inset 0 -0.5px 0 0 $cloudy-blue;
    background-color: $white;
    border-bottom-left-radius: $border-radius;
    border-bottom-right-radius: $border-radius;
  }
}

.downloads-list {
  display: grid;
  grid-template-columns: 2fr;
  grid-template-rows: 1fr;
  grid-gap: 1rem;

  @media only screen and (min-width: 640px) {
    grid-template-columns: 1fr 1fr;
  }

  .download-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 2rem;

    @media only screen and (min-width: 640px) {
      margin-bottom: 0;
    }
  }

  .download-img {
    width: 100%;
    max-width: 191px;
    margin-bottom: 1rem;
  }

  .download-link {
    font-size: 0.875rem;
    color: $greeny-blue;
  }
}

// set variables
$icon-color: transparent; // default color for your icon system

.icon {
  font-style: normal;
  display: inline-block;
  position: relative;
  color: $icon-color;

  &:before,
  &:after {
    content: '';
    position: absolute;
  }

  &-warning {
    &::before {
      content: url(../../assets/img/ico-warning.svg);
      width: 2rem;
      top: 30%;
    }
  }
}
</style>
